import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DegreeTypeFormatAttendanceRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 3 &&
			indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE) &&
			indexableFilters.some((_) => _.type === ParameterType.ATTENDANCE) &&
			indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DEGREE_TYPE_FORMAT_ATTENDANCE_ROUTE,
			params: {
				degree_type: this.extractPath(filters.find((_) => _.type === ParameterType.DEGREE_TYPE)),
				attendance: this.extractPath(filters.find((_) => _.type === ParameterType.ATTENDANCE)),
				delivery_method: this.extractPath(filters.find((_) => _.type === ParameterType.DELIVERY_METHOD)),
			},
		};
	}
}